// extracted by mini-css-extract-plugin
export default {"pane":"Conversations-module__pane__fH1eo_a"};